module.exports = __webpack_public_path__ + "img/2057.87fecf24.jpg";